module.exports = __webpack_public_path__ + "img/s9-dialog2.57c54d92.png";